import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlayIcon, ArrowDownIcon } from 'lucide-react';
import { QuoteOverlay } from './QuoteOverlay';
const heroImages = ['https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&q=80', 'https://cdn.magicpatterns.com/uploads/254gsweUo5hVSPSHyEupQB/HVAC.jpg', 'https://cdn.magicpatterns.com/uploads/2kN7V4j6E8Ra5mMH83Bzov/mfm.webp', 'https://cdn.magicpatterns.com/uploads/3XW5NpAMJMCuH3srhXLsXz/office.png'];
export function HeroV2() {
  const [currentImage, setCurrentImage] = useState(0);
  const [isQuoteOverlayOpen, setIsQuoteOverlayOpen] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative h-screen min-h-[600px] md:min-h-[700px] overflow-hidden" data-id="element-260">
      {/* Background images — z-0 */}
      <div className="absolute inset-0" data-id="element-261">
        <AnimatePresence mode="popLayout" data-id="element-262">
          <motion.img key={currentImage} src={heroImages[currentImage]} alt="Commercial HVAC installation" className="absolute inset-0 w-full h-full object-cover" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 1.2,
          ease: 'easeInOut'
        }} data-id="element-263" />
        </AnimatePresence>
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-primary-dark/55" data-id="element-264"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/70 via-primary-dark/20 to-primary-dark/60" data-id="element-265"></div>

      {/* All foreground content */}
      <div className="relative z-10 h-full flex flex-col" data-id="element-266">
        {/* Spacer for fixed nav */}
        <div className="shrink-0 h-24 md:h-28" data-id="element-267"></div>

        {/* Hero content — center-left */}
        <div className="flex-1 flex flex-col justify-end px-8 md:px-12 lg:px-16 pb-16 md:pb-20 min-h-0" data-id="element-268">
          <div className="max-w-4xl" data-id="element-269">
            <motion.h1 initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.3
          }} className="text-5xl md:text-7xl lg:text-8xl text-white font-serif leading-[1.05] mb-8 tracking-tight" data-id="element-270">
              Commercial AC
              <br data-id="element-271" />
              installation &<br data-id="element-272" />
              maintenance
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} data-id="element-273">
              <button onClick={() => setIsQuoteOverlayOpen(true)} className="group inline-flex items-center gap-4 bg-white/10 backdrop-blur-md hover:bg-white/20 text-white pl-6 pr-2 py-2 rounded-full transition-all duration-300" data-id="element-274">
                <span className="text-sm font-medium" data-id="element-275">Get a free quote</span>
                <div className="w-10 h-10 bg-accent rounded-full flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-276">
                  <PlayIcon className="w-4 h-4 text-white ml-0.5 fill-white" data-id="element-277" />
                </div>
              </button>
            </motion.div>
          </div>
        </div>

        {/* Bottom bar — tagline left, discover more right */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="px-8 md:px-12 lg:px-16 pb-8 md:pb-10 flex justify-between items-end shrink-0" data-id="element-278">
          <div className="text-white/60 text-sm leading-relaxed" data-id="element-279">
            Nationwide Daikin D1+ Premier Partners.
            <br data-id="element-280" />
            Based in Coventry, West Midlands.
          </div>

          <a href="#partner-logos" className="hidden md:flex items-center gap-2 text-white/60 hover:text-white text-sm transition-colors" data-id="element-281">
            <span data-id="element-282">Discover more</span>
            <ArrowDownIcon className="w-4 h-4 animate-bounce" data-id="element-283" />
          </a>
        </motion.div>
      </div>

      <QuoteOverlay isOpen={isQuoteOverlayOpen} onClose={() => setIsQuoteOverlayOpen(false)} data-id="element-284" />
    </section>;
}